export * from './MenuHeaderDetails.ui';
